import _ from 'lodash';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../components/shared';

import Image from '../../components/shared/image.component';

const HOMiiLifeSection = (props) => {
    
    return (

        <div className='homii-life-section-section-container'>

            <div className='container-root container-root-maxWidthMd option-section-container-settings'>

                <FadeInAnimation>

                    <div>

                        <h3 className='homii-life-section-title' id="options_header">
                            {props.title}
                        </h3>

                    </div>

                </FadeInAnimation>

                {renderTextSection(props)}

            </div>
            
        </div>

    );
};

function renderTextSection(props) {
    return (
        <div>
            <div className='main-grid-container main-grid-spacing-xs-4'>
                {renderIcons(props)}
            </div>
        </div>
    );
}

function renderIcons(props) {
    if (!props.icons) {
        return null;
    }

    return _.map(props.icons, (icon, index) => {
        const iconSrc = _.get(icon, 'icon_image.url');
        const iconTitle = _.get(icon, 'icon_title');
        const iconParagraph = _.get(icon, 'icon_paragraph');

        return (

            <div className='main-grid-item main-grid-md-6 main-grid-sm-12' key={index}>

                <FadeInAnimation>

                    <div className='homii-life-section-icon-and-text-container'>

                        <div className='about-section-icon-container'>

                            <Image
                                src={iconSrc}
                                alt="icon"
                                className='homii-life-section-icon-image'
                                isOldImage
                            />

                        </div>

                        <div>

                            <h5 className='homii-life-section-white-text'>{iconTitle}</h5>

                            <p className='homii-life-section-white-text-opacity'>{iconParagraph}</p>

                        </div>

                    </div>

                </FadeInAnimation>

            </div>
        );
    });
}

export default HOMiiLifeSection;

HOMiiLifeSection.propTypes = {
    title: PropTypes.string,
};
